var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block my-3 -mx-3 border-b border-gray-300"})
}
var staticRenderFns = []

export { render, staticRenderFns }